import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { StorageManagerService } from '../../shared/services/index';
import { DataScopesEnum } from '../../shared/enums/index';

@Component({
  selector: 'app-base-accordion',
  template: '',
  styleUrls: ['./base-accordion.component.scss']
})
export class BaseAccordionComponent implements OnInit {

  dataScope: string;

  @Input() itemData: any;
  @Input() mapArray: any;
  @Input() readOnly: boolean;
  @Input() sppModel: boolean;
  @Input() sppDevice: boolean;

  defaultPropsArray: string[] = [];

  itemType: string;
  applicableRegulation: string;
  deviceForm: FormGroup;
  dataScopeEnum = DataScopesEnum;
  itemDetails = false;

  // for Edit form validation
  formErrors = {};
  validationMessages = {};

  constructor(protected fb: FormBuilder, protected storage: StorageManagerService) { }

  ngOnInit() {

    this.itemType = this.itemData.documentType;
  }

  getMapInnerPathName(field: string): any {

    let retVal: any;

    retVal = this.mapArray.find(p => p.key.toLowerCase() === field.toLowerCase());

    if (retVal) {
      retVal = retVal.value.split('/');
    }

    return retVal;
  }

  isDefault(field: string): string {

    return this.defaultPropsArray.includes(field) ? 'highlight-fill' : '';
  }

  displayItemData(field: string): string {

    let retVal: any;
    let prop: any;
    let propValue: string;
    let itemValuePath = [];
    let itemPropsPathSegment: any;
    let defaultPropsPathSegment: any;

    this.itemType = this.itemData.documentType;

    if (this.itemData && field) {

      prop = this.mapArray.find(p => p.key.toLowerCase() === field.toLowerCase());

      if (prop) {
        propValue = prop.value;

        if (propValue) {

          // Multi path value
          if (propValue.indexOf('/') > -1) {

            if (propValue.indexOf('<dataScope>') > -1) {

              propValue = propValue.replace('<dataScope>', this.dataScope);
            }

            if (propValue.indexOf('<documentType>') > -1) {

              propValue = propValue.replace('<documentType>', this.itemType + 'Data');
            }

            itemValuePath = propValue.split('/');

            if (itemValuePath && itemValuePath.length > 0) {

              // Top level item data
              itemPropsPathSegment = this.itemData;

              // Get Default settings to be able to use it if no data is for the dataScope.
              defaultPropsPathSegment = this.itemData;

              itemValuePath.forEach(path => {

                // if dataScope segment or value is undefined check if it exists in Default.
                if (itemPropsPathSegment && Object.keys(itemPropsPathSegment).length) {

                  itemPropsPathSegment = itemPropsPathSegment[path];

                  // reached the datascope level - get the default first to be able use it if datascope value is not found.
                  if (path.toLowerCase() === this.dataScope.toLowerCase()) {
                    path = 'default';
                  }

                  // get value from the default
                  if (defaultPropsPathSegment) {
                    defaultPropsPathSegment = defaultPropsPathSegment[path];
                  }

                } else {
                  if (defaultPropsPathSegment) {
                    if (!Array.isArray(defaultPropsPathSegment)) {
                      defaultPropsPathSegment = defaultPropsPathSegment[path];
                    }
                  }
                }
              });
            }

            // should allow the blank space so testing it against the undefined
            if (itemPropsPathSegment !== undefined && itemPropsPathSegment !== null) {

              if (typeof itemPropsPathSegment === 'object' && !Object.keys(itemPropsPathSegment).length) {
                itemPropsPathSegment = '';
              }

              retVal = itemPropsPathSegment;
            } else {

              retVal = defaultPropsPathSegment;

              if (defaultPropsPathSegment) {
                this.defaultPropsArray.push(field);
              }
            }
          } else {

             // Single path value
             retVal = this.itemData[propValue];
          }
       }
      }
    }

    return retVal;
  }

  /**
     * The function drills to down from the FormGroup or FormArray down
     * to the AbstractControl in order to check if the value is entered.
     * Populates the FormErrors object based on the Validators attached to the formControls.
     * @param {FormGroup} group passed by the form validation.
     */
    logValidationErrors(group: FormGroup = this.deviceForm): void {
      Object.keys(group.controls).forEach((key: string) => {
          const abstractControl = group.get(key);

          this.formErrors[key] = '';
          if (
              abstractControl &&
              !abstractControl.valid &&
              (abstractControl.touched || abstractControl.dirty)
          ) {
              const messages = this.validationMessages[key];

              for (const errorKey in abstractControl.errors) {
                  if (errorKey) {
                      this.formErrors[key] += messages[errorKey] + ' ';
                  }
              }
          }

          if (abstractControl instanceof FormGroup) {
              this.logValidationErrors(abstractControl);
          }

          // We need this additional check to get to the FormGroup
          // in the FormArray and then recursively call this
          // logValidationErrors() method to fix the broken validation
          if (abstractControl instanceof FormArray) {
              for (const control of abstractControl.controls) {
                  if (control instanceof FormGroup) {
                      this.logValidationErrors(control);
                  }
              }
          }
      });
  }

  getApplicableRegulationString(): string {
    // Since the record may have been imported with 'default' or 'eudamed' data scopes, take the applicableRegulation property from 'default' if 'eudamed' is unavailable
    let applicableRegulationStr = '';
    if (this.itemData.modelData.hasOwnProperty('eudamed') && this.itemData.modelData.eudamed.applicableRegulation) {
      applicableRegulationStr = this.itemData.modelData.eudamed.applicableRegulation;
    }
    else if (this.itemData.modelData.hasOwnProperty('default') && this.itemData.modelData.default.applicableRegulation) {
      applicableRegulationStr = this.itemData.modelData.default.applicableRegulation;
    }
    else {
      // Neither 'default' or 'eudamed' were found, return false since the check cannot be preformed.
      return '';
    }

    return applicableRegulationStr.toUpperCase();
  }

}
